// extracted by mini-css-extract-plugin
module.exports =  {"attributes-tooltip-wrapper":"O_XPlso","attributesTooltipWrapper":"O_XPlso","attribute-item":"IZTa5C5","attributeItem":"IZTa5C5"};